import Component from 'component';
import { BREAKPOINT } from '../constants';

class ContentSlider extends Component {
  constructor(el) {
    super(el);
    this.initSlick();
  }

  setupDefaults() {
    this.dom = {
      $slider: this.$el.find('.content-slider__slider'),
      $dotsContainer: this.$el.find('.content-slider__dots')
    };
  }

  initSlick() {
    const _that = this;
    _that.dom.$slider.slick({
      infinite: false,
      dots: true,
      appendDots: _that.dom.$dotsContainer,
      prevArrow:
        '<img class="slick-prev slick-arrow" src="/dist/sites/bb/images/contentManaged/icons/icon-arrow-left-shadow.svg" alt="prev slide">',
      nextArrow:
        '<img class="slick-next slick-arrow" src="/dist/sites/bb/images/contentManaged/icons/icon-arrow-right-shadow.svg" alt="next slide">',
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: BREAKPOINT.desktop,
          settings: {
            infinite: false,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}

export default ContentSlider;



// WEBPACK FOOTER //
// ./src/bb/js/components/ContentSlider.js